import { readonly } from "vue";
import { useWindowSize } from "@vueuse/core";

// Should be in sync with SCSS variables (variables.scss)
const DesktopMinScreenWidth = 1280;
const TabletMaxScreenWidth = 768;
const PhoneMaxScreenWidth = 576;

// One shared width for every consumer (including hot components like Button that
// read the breakpoint on each instance). useWindowSize is SSR-safe: on the server
// `width` stays at its initial value until the client mounts and corrects it.
const { width: screenWidth } = useWindowSize();

const isDesktop = computed(() => screenWidth.value > DesktopMinScreenWidth);
const isTablet = computed(() => screenWidth.value <= TabletMaxScreenWidth && screenWidth.value > PhoneMaxScreenWidth);
const isPhone = computed(() => screenWidth.value <= PhoneMaxScreenWidth);

export function useScreenSize() {
  return {
    isDesktop,
    isTablet,
    isPhone,

    screenWidth: readonly(screenWidth),
  };
}
